import { E as s, P as u, T as t, F as m } from "./index-Ct-O5af5.js";
import { defineStore as H } from "pinia";
import { ref as d } from "vue";
const f = {
  doc: [
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  ],
  pdf: ["application/pdf"],
  image: ["image/jpeg", "image/png", "image/jpg"],
  audio: ["audio/mp3", "audio/webm", "audio/mpeg"],
  video: ["video/mp4", "video/quicktime"],
  other: ["application/zip", "application/x-zip-compressed", "text/csv"]
}, N = Object.entries(f).reduce((e, [c, n]) => (e.push(...n), e), []).flat().join(","), Y = N;
s.ANGRY, s.HAPPY, s.LOVE, s.SAD, s.SURPRISED, s.FIST_BUMP;
u.DOCUMENT;
u.MEDIA;
const $ = u.PREVIEW, q = u.FAILED, h = {
  id: "microphone",
  icon: "Microphone",
  command: t.MICROPHONE,
  label: "Voice note – max 5 MB",
  position: "bottom-right",
  persistent: !0
}, C = {
  id: "emoji",
  icon: "CustomEmoji",
  command: t.EMOJI,
  label: "Emoji",
  position: "top-left"
}, L = {
  id: "link",
  icon: "Link",
  command: t.LINK,
  label: "Link",
  position: "top-right"
}, B = {
  id: "bulletedList",
  icon: "ListBullet",
  label: "List",
  command: t.BULLETED_LIST,
  position: "bottom-right"
}, v = {
  id: "bold",
  icon: "Bold",
  label: "Bold",
  command: t.BOLD
}, b = {
  id: "italic",
  icon: "Italic",
  label: "Italic",
  command: t.ITALIC
}, w = {
  id: "underline",
  icon: "Underline",
  label: "Underline",
  command: t.UNDERLINE
}, F = {
  id: "strikethrough",
  icon: "StrikeThrough",
  label: "Strikethrough",
  command: t.STRIKETHROUGH
}, E = {
  id: "checkbox",
  icon: "ListCheck",
  label: "Checklist",
  command: t.TODO_LIST
}, T = {
  id: "indent",
  icon: "Indent",
  label: "Indent",
  command: t.INDENT
}, y = {
  id: "outdent",
  icon: "Outdent",
  label: "Outdent",
  command: t.OUTDENT
}, I = {
  id: "media",
  icon: "Paperclip",
  label: "Attachment",
  command: t.MEDIA
}, M = {
  id: "mentionFrame",
  icon: "Film",
  label: "Mention frame",
  command: t.MENTION_FRAME
}, R = {
  id: "bulletedList",
  icon: "ListBullet",
  label: "Bulleted list",
  command: t.BULLETED_LIST
}, U = {
  id: "numberedList",
  icon: "ListNumber",
  label: "Numbered list",
  command: t.NUMBERED_LIST
}, J = [
  C,
  v,
  b,
  w,
  F,
  R,
  U,
  T,
  y,
  I,
  L,
  h,
  E,
  M
], Q = {
  bold: v,
  italic: b,
  underline: w,
  strikethrough: F,
  todoList: E,
  indent: T,
  outdent: y,
  attachment: I,
  mentionFrame: M,
  bulletedList: R,
  numberedList: U
}, X = {
  microphone: h,
  emoji: C,
  link: L,
  list: B
};
Array.from({ length: 20 }).map((e, c) => ({
  value: `${c}`,
  label: `${(Math.random() * 1e3).toFixed(10)}`
}));
const ee = `<svg viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg">
<path d="M256 0H320C337.7 0 352 14.3 352 32V96C352 113.7 337.7 128 320 128H256C238.3 128 224 113.7 224 96V32C224 14.3 238.3 0 256 0ZM64 64H192V112C192 138.5 213.5 160 240 160H336C362.5 160 384 138.5 384 112V64H512C547.3 64 576 92.7 576 128V448C576 483.3 547.3 512 512 512H64C28.7 512 0 483.3 0 448V128C0 92.7 28.7 64 64 64ZM176 437.3C176 443.2 180.8 448 186.7 448H389.3C395.2 448 400 443.2 400 437.3C400 407.8 376.1 384 346.7 384H229.3C199.8 384 176 407.9 176 437.3ZM288 352C304.974 352 321.252 345.257 333.255 333.255C345.257 321.252 352 304.974 352 288C352 271.026 345.257 254.747 333.255 242.745C321.252 230.743 304.974 224 288 224C271.026 224 254.747 230.743 242.745 242.745C230.743 254.747 224 271.026 224 288C224 304.974 230.743 321.252 242.745 333.255C254.747 345.257 271.026 352 288 352Z" fill="currentColor"/>
</svg>
`, oe = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M469.3 19.3l23.4 23.4c25 25 25 65.5 0 90.5l-56.4 56.4L322.3 75.7l56.4-56.4c25-25 65.5-25 90.5 0zM44.9 353.2L299.7 98.3 413.7 212.3 158.8 467.1c-6.7 6.7-15.1 11.6-24.2 14.2l-104 29.7c-8.4 2.4-17.4 .1-23.6-6.1s-8.5-15.2-6.1-23.6l29.7-104c2.6-9.2 7.5-17.5 14.2-24.2zM249.4 103.4L103.4 249.4 16 161.9c-18.7-18.7-18.7-49.1 0-67.9L94.1 16c18.7-18.7 49.1-18.7 67.9 0l19.8 19.8c-.3 .3-.7 .6-1 .9l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c.3-.3 .6-.7 .9-1l45.1 45.1zM408.6 262.6l45.1 45.1c-.3 .3-.7 .6-1 .9l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c.3-.3 .6-.7 .9-1L496 350.1c18.7 18.7 18.7 49.1 0 67.9L417.9 496c-18.7 18.7-49.1 18.7-67.9 0l-87.4-87.4L408.6 262.6z" fill="currentColor" /></svg>', te = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z" fill="currentColor" /></svg>', ne = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h82.7L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z" fill="currentColor" /></svg>', ce = H("fileManager", () => {
  const e = d(null), c = d({}), n = d(null), i = d({});
  return {
    files: i,
    uploadingStatus: c,
    addFile: async (o) => {
      const { name: a, path: x, fileid: r, mimetype: D, file: k } = o;
      try {
        c.value[r] = o?.error ? m.uploadFailed : m.pending;
        const p = O(D), g = { fileData: k, id: r, label: a, s3Path: x || "", type: p, url: "" };
        return i.value[r] = g, g;
      } catch (p) {
        c.value[r] = m.uploadFailed, console.error("Error adding file:", p);
      }
    },
    actionQueue: n,
    fetchResourceURL: async ({
      path: o
    }) => {
      try {
        return e.value ? await e.value({ path: o }) : { url: void 0, message: "No fetchResourceFunction" };
      } catch (a) {
        return console.error("Error fetching resource URL:", a), { url: void 0, message: "Error fetching resource URL" };
      }
    },
    removeFile: (o) => {
      n.value = { id: o, action: "delete" };
    },
    stopUploading: (o) => {
      n.value = { id: o, action: "stop" };
    },
    retryUpload: (o) => {
      n.value = { id: o, action: "upload" };
    },
    setFetchResourceFunction: (o) => {
      e.value = o;
    },
    fetchResourceFunction: e,
    setResourceURL: ({ id: o, url: a }) => {
      i.value[o] && (i.value[o].resourceURL = a);
    },
    FileStatus: m
  };
}), l = f;
Object.values(l).flat();
const P = (e) => ({
  doc: "document",
  pdf: "document",
  image: "media",
  audio: "media",
  video: "media",
  other: "other"
})[e] ?? "other", O = (e) => {
  switch (!0) {
    case l.doc.includes(e):
      return "doc";
    case l.pdf.includes(e):
      return "pdf";
    case l.image.includes(e):
      return "image";
    case l.audio.includes(e):
      return "audio";
    case l.video.includes(e):
      return "video";
    default:
      return "other";
  }
}, ie = (e, c) => {
  const n = O(e.mimetype), i = P(n);
  return {
    path: e.path,
    type: i,
    accept_type: n,
    mimetype: e.mimetype,
    name: e.name,
    systemType: i,
    acceptType: n,
    file_raw: {},
    // This should be populated based on your logic
    fileRaw: {},
    // This should be populated based on your logic
    position: c
    // This should be set based on your logic
  };
};
export {
  $ as P,
  q as U,
  Y as a,
  O as b,
  ie as c,
  X as d,
  oe as e,
  te as f,
  ne as g,
  ee as h,
  Q as s,
  J as t,
  ce as u
};
